const staticRoadmapData = [
    {
        phase: "Phase 1",
        items: [
            "Website Launch",
            "Whitepaper Release",
            "Community Formation",
            "Marketing Push",
            "Token Launch",
        ],
    },
    {
        phase: "Phase 2",
        items: [
            "Final Mixer Testing",
            "Mixer goes live",
            "Telegram-based deposits",
            "Stealth withdrawals activated",
            "Private buy/sell commands",
            "Encrypted confirmations",
            "Relayer obfuscation layer",
            "P2P OTC swaps testing & beta"
        ],
    },
    {
        phase: "Phase 3",
        items: [
            "Improve stealth wallet rotation",
            "Improved relayer privacy layer",
            "Batching and randomized execution logic",
            "Trade pattern scrambling",
            "Enhanced telegram privacy UX",
            "Final Promptify Tests",
            "Full Release of P2P OTC swaps",
        ],
    },
    {
        phase: "Phase 4",
        items: [
            "Full Promptify launch",
            "Relayer speed optimization",
            "Stealth Wallet Load Balancing",
            "Batching & Delay refinement",
            "Further partnerships and expansion",
            "Cross Chain support prep",
            "Bot stability and monitoring",
        ],
    },
];

export default staticRoadmapData;